import { createApp } from "vue";
import App from "./App.vue";
import "nprogress/nprogress.css";

import { createRouter, createWebHistory } from "vue-router";
import MarketPane from "./components/MarketPane.vue";
import CollectionPane from "./components/CollectionPane.vue";
import Register from "./components/Register.vue";
import Login from "./components/Login.vue";
import Logout from "./components/Logout.vue";
import TopUserPane from "./components/TopUserPane.vue";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", redirect: "/market", meta: { requireAuthen: true } },
        { path: "/market", component: MarketPane, meta: { requireAuthen: true } },
        { path: "/collection", component: CollectionPane, meta: { requireAuthen: true } },
        { path: "/register", component: Register },
        { path: "/login", component: Login },
        { path: "/logout", component: Logout,  meta: { requireAuthen: true } },
        { path: "/topuser", component: TopUserPane,  meta: { requireAuthen: true }  },
        { path: "/topuser/:user", component: TopUserPane },
    ],
});

router.beforeEach(function (to, from, next) {
    if (to.meta.requireAuthen) {
        if (app.config.globalProperties.$authenticated) {
            next();
        }
        else {
          // not authenticated yet
          alert("Please login to your account");
          next("/login");  
        }
    }
    else {
        // the user is heading to the public page
        next();
    }
    // console.log("I am from beforeEach");
    // console.log(to);
    // console.log(from);
    // next();
})

const app = createApp(App);
app.use(router);
app.mount('#app');

//  Create global properties
app.config.globalProperties.$displayName = "";
app.config.globalProperties.$idToken = "";
app.config.globalProperties.$expiresIn = "";
app.config.globalProperties.$authenticated = "";
app.config.globalProperties.$wallet = 1;


export { app };